import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_PLAYSTATION_SUCCESS,
  DELETE_PLAYSTATION_SUCCESS,
  GET_PLAYSTATION_FAIL,
  GET_PLAYSTATION_SUCCESS,
  UPDATE_PLAYSTATION_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  playstation: [],
  defective: [],
  exports: [],
  error: {},
};

const PLAYSTATION = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PLAYSTATION_SUCCESS:
      return {
        ...state,
        playstation: action.payload.playstation,
        defective: action.payload.defective,
      };

    case GET_PLAYSTATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_PLAYSTATION_SUCCESS:
      return {
        ...state,
        playstation: [...state.playstation, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_PLAYSTATION_SUCCESS:
      return {
        ...state,
        playstation: state.playstation.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_PLAYSTATION_SUCCESS:
      return {
        ...state,
        playstation: state.playstation.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default PLAYSTATION;
